export enum AuthDivergenceActionEnum {
  ACCEPTED = 'ACCEPTED',
  REQUEST_REANALYSIS = 'REQUEST_REANALYSIS'
}
